// extracted by mini-css-extract-plugin
module.exports = {"figure":"video-thumnail_figure__2anqi","duration":"video-thumnail_duration__mbULu","figure__image":"video-thumnail_figure__image__14d8F"};